import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";

const MOBILE_MQ = "(max-width: 767px)";

function ResponsiveToaster() {
  const [mobile, setMobile] = useState(() => window.matchMedia(MOBILE_MQ).matches);
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MQ);
    const onChange = (e) => setMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return <Toaster position={mobile ? "top-center" : "bottom-right"} richColors offset={mobile ? 16 : 96} />;
}
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Planbord from "@/pages/Planbord";
import Vandaag from "@/pages/Vandaag";
import Projecten from "@/pages/Projecten";
import ProjectDetail from "@/pages/ProjectDetail";
import Medewerkers from "@/pages/Medewerkers";
import Voertuigen from "@/pages/Voertuigen";
import Dashboard from "@/pages/Dashboard";
import Materiaal from "@/pages/Materiaal";
import Uren from "@/pages/Uren";
import Instellingen from "@/pages/Instellingen";
import Marketing from "@/pages/Marketing";
import Signup from "@/pages/Signup";
import Billing from "@/pages/Billing";
import BillingSuccess from "@/pages/BillingSuccess";
import SetPassword from "@/pages/SetPassword";
import { Forgot, Reset } from "@/pages/PasswordReset";
import { Privacy, Voorwaarden } from "@/pages/Legal";
import AdminDashboard from "@/pages/AdminDashboard";
import CookieBanner from "@/components/CookieBanner";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return (
    <div className="flex items-center justify-center h-screen text-slate-500 font-semibold">Laden…</div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function OfficeOnly({ children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "UITVOERDER") return <Navigate to="/vandaag" replace />;
  return children;
}

function OwnerOnly({ children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role !== "OWNER") return <Navigate to="/planbord" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public */}
              <Route path="/" element={<Marketing />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/voorwaarden" element={<Voorwaarden />} />
              <Route path="/login" element={<Login />} />
              <Route path="/billing/success" element={<BillingSuccess />} />
              <Route path="/welkom/:token" element={<SetPassword />} />
              <Route path="/wachtwoord-vergeten" element={<Forgot />} />
              <Route path="/reset/:token" element={<Reset />} />

              {/* Super-admin (auth handled inside component; email gate) */}
              <Route path="/admin-dashboard" element={<Protected><AdminDashboard /></Protected>} />

              {/* App (protected + Layout wrapper) */}
              <Route element={<Protected><Layout /></Protected>}>
                <Route path="/planbord" element={<OfficeOnly><Planbord /></OfficeOnly>} />
                <Route path="/vandaag" element={<Vandaag />} />
                <Route path="/dashboard" element={<OfficeOnly><Dashboard /></OfficeOnly>} />
                <Route path="/projecten" element={<Projecten />} />
                <Route path="/projecten/:id" element={<ProjectDetail />} />
                <Route path="/medewerkers" element={<OfficeOnly><Medewerkers /></OfficeOnly>} />
                <Route path="/voertuigen" element={<OfficeOnly><Voertuigen /></OfficeOnly>} />
                <Route path="/materiaal" element={<OfficeOnly><Materiaal /></OfficeOnly>} />
                <Route path="/uren" element={<OfficeOnly><Uren /></OfficeOnly>} />
                <Route path="/instellingen" element={<OfficeOnly><Instellingen /></OfficeOnly>} />
                <Route path="/billing" element={<OwnerOnly><Billing /></OwnerOnly>} />
              </Route>

              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
          <ResponsiveToaster />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
